import { styled } from 'styled-components';
import { Flex } from '../layout/Flex';
import { COLORS } from '@ydistri/theme';

export const GreyFlex = styled(Flex)`
  padding: 1rem;
  background-color: ${COLORS.GREY_LIGHT};
  border-radius: 1rem;
  border: 1px dashed ${COLORS.GREY_BORDER};
  margin-top: 16px;
  flex-grow: 1;
`;
